export const socialsData = {
    // github: 'https://github.com/',
    facebook: 'https://www.facebook.com/muasab.sabir',
    linkedIn: 'https://www.linkedin.com/in/muaasab-sabir',
    instagram: 'https://www.instagram.com/muaasab.sabir',
    whatsapp: 'https://wa.me/message/3D4HZTR5S7ONE1',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}